<template>
	<div id="telTest">
		<div v-if="show_type === 2 || show_type == 3" class="tishi">
			<p style="font-size: 25px; font-weight :549; color:#313541; line-height: 35px;">
				白名单观看
			</p>
			<p></p>
			<p style="font-size: 14px;line-height: 20px;margin-top: 5px;color: #7B838E;">
				只允许添加了白名单的用户观看
			</p>
		</div>

		<div v-if="show_type === 1" class="tishi">
			<p style="font-size: 25px; font-weight :549; color:#313541; line-height: 35px;">
				登记信息
			</p>
			<p></p>
			<p style="font-size: 14px;line-height: 20px;margin-top: 5px;color: #7B838E;">
				为了保障课程知识产权，需登记学员信息核实后即可观看
			</p>
		</div>

		<div style="margin-top: 20px;" v-if="show_type === 2">
			<div class="content-box">
				<span class="content-box_span">手机号</span>
				<input v-bind:value="phone" placeholder="请输入内容" type="number" v-on:input="phone = $event.target.value" class="content-box_input"/>
			</div>
			<div v-if="need_check_bool" class="content-box">
				<span class="content-box_span">验证码</span>
				<input v-bind:value="value" placeholder="请输入内容" v-on:input="value = $event.target.value" class="content-box_input"/>
				<button v-if="phone_text == '获取验证码'" @click="sendMsg(phone, 2)" class="content-box_code_buttom">
					{{ phone_text }}
				</button>
				<button v-else class="content-box_code_buttom" style="background-color: #fff;color: #afafaf;border: 1px solid #afafaf;">
					{{ phone_text }}
				</button>
			</div>
		</div>


			<div style="margin-top: 20px;" v-if="show_type === 3">
			<div class="content-box">
				<span class="content-box_span">账号</span>
				<input v-model="account_white_name" placeholder="请输入账号" type="text"  class="content-box_input"/>
			</div>
			<div class="content-box">
				<span class="content-box_span">密码</span>
				<input v-model="account_white_password" placeholder="请输入密码" type="text" class="content-box_input"/>
			</div>
		</div>

		<div v-if="show_type === 1" style="margin: 30px 0 0 0px;">
			<div v-for="(item, index) in list" :key="index">
				<div v-if="item.type == 1">
					<div class="content-box">
						<span class="content-box_span"><span class="content-box_title" v-if="item.is_field == 'yes'" style="color: red;">* </span>{{ item.name_title }}</span>
						<input class="content-box_input" type="number" placeholder="请输入内容" v-bind:value="item.value" v-on:input="inputChange(item,index,$event)"/>
					</div>
					<div class="content-box" v-if="item.is_phone_check == 'yes'">
						<span class="content-box_span"><span class="content-box_title" v-if="item.is_field == 'yes'" style="color: red;">* </span>验证码</span>
						<input v-bind:value="item.code"  type="number" v-on:input="item.code = $event.target.value" class="content-box_input"/>
						<button v-if="phone_text == '获取验证码'" placeholder="请输入内容" @click="sendMsg(item.value, 1)" class="content-box_code_buttom">
							{{ phone_text }}
						</button>
						<button v-else class="content-box_code_buttom" style="background-color: #fff;color: #afafaf;border: 1px solid #afafaf;">
							{{ phone_text }}
						</button>
					</div>
				</div>
				<div style="border-bottom: #e5e5e5 solid 1px;display:flex;align-items: center;" v-if="item.type == 2">
					<span class="content-box_span"><span class="content-box_title" v-if="item.is_field == 'yes'" style="color: red;">* </span>{{ item.name_title }}</span>
					<input v-bind:value="item.value" placeholder="请输入内容" v-on:input="item.value = $event.target.value" class="content-box_input"/>
				</div>
				<div style="border-bottom: #e5e5e5 solid 1px;display:flex;align-items: center;" v-if="item.type == 3">
					<span class="content-box_span"><span class="content-box_title" v-if="item.is_field == 'yes'" style="color: red;">* </span>{{ item.name_title }}</span>
					<input v-bind:value="item.value" placeholder="请输入内容" v-on:input="item.value = $event.target.value" class="content-box_input"/>
				</div>
			</div>
		</div>
		<div style="height: 80px;width: 100%;"></div>
		<div style="width: 100%;bottom: 0px;left: 0px;text-align: center;">
			<van-button style="width:80%;display:inline-block" @click="commitData" type="primary" size="large" block>进入观看
			</van-button>
		</div>
	</div>
</template>

<script>
  import Vue from "vue";
	import { Toast,Button } from 'vant';
   Vue.use(Button);
	import tool from "../../kits/Tools.js";
	export default {
		created() {
		},
		props: {
			show_type: {
				type: Number,
				default: 1,
			},
			fans_id: {
				type: Number,
				default: "",
			},
			ds_id: {
				type: Number | String,
				default: "",
			},
			need_check_bool: {
				type: Boolean,
				default: true,
			}
		},
		data() {
			return {
				phone: "",
				value: "",
				ds_data: {},
				list: [],
				phone_text: "获取验证码",
				account_white_name:"",
				account_white_password:""
			};
		},
		watch:{
       ds_id:{
        handler: function(newVal, oldVal) {
           if (newVal) {
              this.getFetchData()
           }
        },
        immediate: true,
     }
		},
		methods: {
			getFetchData(){
					var that = this;
					var option = "ds_id=" + this.ds_id;
					this.axios
						.post(tool.baseUrl1() + "/wap/index/getCheckPlayParams", option)
						.then(function(data) {
							console.log("data:", data);
							that.ds_data = data.data.data;
							that.list = JSON.parse(data.data.data.params);
							for (let index in that.list) {
								const obj = that.list[index];
								obj.value = "";
								obj.phone = "";
							}
						})
						.catch(function(data) {
							// Toast("网络错误！");
							console.log("错误" + data);
						});
			},
			inputChange(item,index,event){
        item.value = event.target.value
			},
			commitData() {
				let that = this;
				if (that.show_type === 1) {
					let obj = {};
					for (let index in this.list) {
						const o = this.list[index];
						obj[o.name_title] = o;
						if (o.type == 1) {
							  if (!(/^1\d{10}$/.test(o.value))) {
										Toast("请输入正确的手机号码");
									return;
								}
						}
					}

					const str = JSON.stringify([obj]);

					const option =
						"ds_id=" +
						this.ds_id +
						"&content=" +
						str +
						"&fans_id=" +
						this.fans_id;
					this.axios
						.post(tool.baseUrl1() + "/wap/index/playerRegist", option)
						.then(function(data) {
							console.log(data);
							if (data.data.code == 200) {
								Toast("登记成功");
								that.$emit("registerok");
							} else {
								Toast(data.data.message);
								console.log(data.data.message);
							}
						})
						.catch(function(data) {
							Toast("网络错误！");
							console.log("错误" + data);
						});
				}else if (that.show_type === 2) {
					const option =
						"ds_id=" +
						this.ds_id +
						"&fans_id=" +
						this.fans_id +
						"&mobile=" +
						that.phone +
						"&code=" +
						that.value;
					this.axios
						.post(tool.baseUrl1() + "/wap/index/whiteNumCheck", option, {
							mobile: that.phone,
							code: that.value,
						})
						.then(function(data) {
							console.log(data);
							if (data.data.code == 200) {
								Toast("登记成功");
								that.$emit("whiteNumOk");
							} else {
								Toast(data.data.message);
								console.log(data.data.message);
							}
						})
						.catch(function(data) {
							Toast("网络错误！");
							console.log("错误" + data);
						});
				}else if (that.show_type === 3) {
           
					 if (that.account_white_name == "") {
						 Toast("账号不能为空！");
						 return
					 }

					 if (that.account_white_password == "") {
						 Toast("密码不能为空！");
						 return
					 }

					const option =
						"ds_id=" +
						this.ds_id +
						"&fans_id=" +
						this.fans_id +
						"&account=" +
						that.account_white_name +
						"&password=" +
						that.account_white_password;
					this.axios
						.post(tool.baseUrl1() + "/customer/whiteList/check", option)
						.then(function(data) {
							console.log(data);
							if (data.data.code == 200 && data.data.data.result) {
								Toast("登录成功");
								that.$emit("whiteNumOk");
							} else {
								Toast("校验失败!");
							}
						})
						.catch(function(data) {
							Toast("网络错误！");
							console.log("错误" + data);
						});

				}

			},
			sendMsg(mobile, type) {
				const self = this;
				let option = "mobile=" + mobile + "&sms_type=" + type;
				this.axios
					.post(tool.baseUrl1() + "/wap/index/sendSMS", option)
					.then(function(data) {
						if (data.data.code == 200) {
							Toast("短信已发送");
							self.phone_text = "60秒重发";
							const timer = setInterval(() => {
								let i = parseInt(self.phone_text);
								if (i == 1) {
									clearInterval(timer);
									self.phone_text = "获取验证码";
									return;
								}
								self.phone_text = i - 1 + "秒重发";
							}, 1000);
						} else {
							Toast(data.data.message);
						}
					})
					.catch(function(data) {
						Toast("网络错误！");
						console.log("错误" + data);
					});
			},
		},
	};
</script>

<style  scoped>
	#telTest {
		top: 0;
		bottom: 0;
		overflow-y: auto;
		overflow-x: hidden;
		position: fixed;
		z-index: 10001;
		background: #f5f5f5;
		width: 100%;
		background-color: white;
	}

	#telTest .content-box {
		position: relative;
		border-bottom: #e5e5e5 solid 1px;
		/* height: 50px; */
		display: flex;
		align-items: center;
	}

	#telTest .content-box_span {
		margin-left: 20px;
		width: 120px;
	  text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	#telTest .content-box_title {
		 	line-height: 13px;
	}

	#telTest .content-box_input {
		height: 48px;
		line-height: 50px;
		margin-left: 10px;
		background: transparent;
		flex: 1;
	}

	#telTest .content-box_code_buttom {
		height: 35px;
		width: 103px;
		background-color: #fff;
		color: #0883fd;
		font-size: 14px;
		border: 1px solid #0883fd;
		border-radius: 17px;
		position: absolute;
		right: 20px;
		top: 7px;
	}

	#telTest input {
		border: 0;
	}

	.head {
		height: 44px;
		width: 100%;
		background-color: white;
		font-size: 17px;
		font-weight: 600;
		line-height: 44px;
		color: #333333;
		text-align: center;
		border-bottom: 1px solid rgb(240, 240, 240);
	}

	#telTest .van-button--primary {
		background-color: #0883fd;
		border: 1px solid #0883fd;
		border-radius: 25px;
	}

	#telTest .van-button--large {
		height: 44px;
		line-height: 42px;
	}

	.tishi {
		margin: 30px 15px 0 15px;
	}

</style>

<style>
   	.van-toast.van-toast--text.van-toast--middle {
			z-index: 11000 !important;
		}
</style>